// Currency bridge for Algolia price filters.
// The Algolia index only holds GBP; EUR support is an approximation so EUR
// users can enter/see prices in their currency while the query stays in GBP.
// Each one-way conversion rounds to an integer, so a round-trip can drift by
// ±1 — `gbpToDisplayOrAnchor` snaps back to a canonical display value when
// the GBP input matches one of the known round-number anchors.

export const getCurrencyConfig = () => (
  window.__currencyConfig || { currency: 'gbp', exchangeRate: 1 }
)

export const isEur = () => getCurrencyConfig().currency === 'eur'
export const isUsd = () => getCurrencyConfig().currency === 'usd'
export const isNonGbp = () => getCurrencyConfig().currency !== 'gbp'

export const currencySymbol = () => {
  switch (getCurrencyConfig().currency) {
    case 'eur': return '€'
    case 'usd': return '$'
    default: return '£'
  }
}

export const gbpToDisplay = (gbp) => {
  const n = Number(gbp)
  if (gbp == null || !Number.isFinite(n)) return gbp
  return isNonGbp() ? Math.round(n * getCurrencyConfig().exchangeRate) : n
}

export const displayToGbp = (value) => {
  const n = Number(value)
  if (value == null || value === '' || !Number.isFinite(n)) return value
  return isNonGbp() ? Math.round(n / getCurrencyConfig().exchangeRate) : n
}

// Display-currency anchors shared by price widgets (slider endpoints and
// mobile presets). Extend here when a new preset is added.
export const PRICE_ANCHORS_DISPLAY = [50, 200, 500, 1500, 50000]

export const gbpToDisplayOrAnchor = (gbp) => {
  const n = Number(gbp)
  if (gbp == null || !Number.isFinite(n)) return gbp
  const rounded = Math.round(n)
  for (const display of PRICE_ANCHORS_DISPLAY) {
    if (displayToGbp(display) === rounded) return display
  }
  return gbpToDisplay(n)
}
